export default __webpack_public_path__ + "static/media/trade-5.e5fb318b.svg";